import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./MenuItem.module.css";
import { Link, NavLink } from "react-router-dom";


const MobileMenuItem = ({ link, title, dropdown, onSelectItem }) => {
  const [open, setOpen] = useState(false);
  const [openClick, setOpenClick] = useState(false);

  const toggleDropdownList = () => setOpenClick(!openClick);

  const renderItem = (item, index) => {
    return (
      <Link to={item.link} key={index}>
        <div className={styles.dropdownItem}>{item.title}</div>
      </Link>
    )
  }

  return (
    <div
      className={classNames(styles.container)}
      onPointerEnter={() => setOpen(true)}
      onPointerLeave={() => !openClick ? setOpen(false) : undefined}
    >
      <NavLink
        to={link}
        exact
        activeClassName={styles.open}
        className={classNames(styles.menuItem, dropdown && styles.dropdownParent)}
        onClick={dropdown ? toggleDropdownList : onSelectItem}
      >
        {title}
      </NavLink>
      {dropdown && openClick && (
        <div onClick={onSelectItem}
          className={classNames(styles.dropdown, {
            [styles.dropdownOpen]: open
          })}
        >
          {dropdown.map(renderItem)}
        </div>
      )}
    </div>
  );
};

MobileMenuItem.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  dropdown: PropTypes.array
};

export default MobileMenuItem;
